import React, { ChangeEvent, useState } from 'react'
import { postForm } from '../utils/api'
import { StudentInterface } from '../types/interface/student.interface'

interface Props {
  student: StudentInterface
  courseName: string | null
  selectedOption: StudentInterface | null
  setSelectedOption: React.Dispatch<
    React.SetStateAction<StudentInterface | null>
  >
}

const UploadCertificate = ({
  student,
  courseName,
  selectedOption,
  setSelectedOption,
}: Props) => {
  const [file, setFile] = useState<File | null>(null)
  // eslint-disable-next-line no-unused-vars
  const [_uploading, setUploading] = useState(false)

  const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0]

    if (file) {
      setFile(file)
    }
  }

  const handleUploadCertificate = async () => {
    if (file) {
      try {
        setUploading(true)

        const formData = new FormData()
        formData.append('file', file)
        formData.append('studentId', student.id)
        formData.append('courseName', courseName ?? '')

        const upload = await postForm('/api/certificates', formData)

        const updatedStudent: StudentInterface = JSON.parse(
          JSON.stringify(selectedOption)
        )

        updatedStudent.certificates = updatedStudent.certificates
          ? [...updatedStudent.certificates, upload.certificate]
          : [upload.certificate]
        setSelectedOption(updatedStudent)

        alert(`UPLOADED ${upload.url}`)
      } catch (error) {
        console.error(error)
      } finally {
        setUploading(false)
      }
    }
  }

  return (
    <div className="flex flex-col gap-5 sm:w-[300px] w-full pl-2">
      <input
        type="file"
        onChange={handleFileChange}
        className="text-primary file:bg-primary file:text-secondary file:border-0 file:border-primary file:cursor-pointer"
      />
      {file && (
        <button
          className="text-secondary bg-primary font-semibold px-3 py-1 rounded-sm flex justify-center max-w-[50%]"
          onClick={handleUploadCertificate}
        >
          Upload
        </button>
      )}
    </div>
  )
}

export default UploadCertificate
